import ContactUsEditor from "./Editors/ContactUsEditor";
import LandingPageEditor from "./Editors/LandingPageEditor";
import LeadershipEditor from "./Editors/LeadershipEditor";
import ProfilePageEditor from "./Editors/ProfilePageEditor";
import SimpleMainPageEditor from "./Editors/SimpleMainPageEditor";

const PageEditor = ({ pageType, pageData, onSave, onCancel, isLoading }) => {
  const renderEditor = () => {
    switch (pageType) {
      case "landing-page":
        return (
          <LandingPageEditor
            data={pageData}
            onSave={onSave}
            onCancel={onCancel}
            isLoading={isLoading}
          />
        );
      case "contact-us":
        return (
          <ContactUsEditor
            data={pageData}
            onSave={onSave}
            onCancel={onCancel}
            isLoading={isLoading}
          />
        );
      case "leadership":
        return (
          <LeadershipEditor
            data={pageData}
            onSave={onSave}
            onCancel={onCancel}
            isLoading={isLoading}
          />
        );
      case "profile":
        return (
          <ProfilePageEditor
            data={pageData}
            onSave={onSave}
            onCancel={onCancel}
          />
        );
      case "top-destinations":
      case "explore-districts":
        return (
          <SimpleMainPageEditor
            data={pageData}
            onSave={onSave}
            onCancel={onCancel}
            isLoading={isLoading}
          />
        );
      default:
        return <div>Page type not supported</div>;
    }
  };

  return <div>{renderEditor()}</div>;
};
export default PageEditor;
